/* eslint-disable */
import React, { useMemo, useState } from 'react';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

import { useDebounce, useTranslate } from '../../../../../../../../hooks';
import {
  useListDepartments,
  useListEmployees,
} from '../../../../../../../../api/react-query';

import { ShiftEmployeeListType } from '../../types';

import './shiftEmployee-list.css';

import {
  AutoComplete,
  CustomRadioGroup,
  RadioButton,
} from '../../../../../../../../components';
import { EmployeeCard } from '../common';
import { Loader } from '../../../../../../../../components/icons/Loader';
import SearchComponent from '../../../../../../../../common/components/SearchComponent';

export function ShiftEmployeeList({
  handleEmployeeSelect,
  firstEmployeeId,
}: ShiftEmployeeListType) {
  const { translate } = useTranslate();
  const [department, setDepartment] = useState<string>('');
  const [search, setSearch] = useDebounce('');

  const handleFilterChange = (id: string) => {
    setDepartment(id);
  };

  const { data, isLoading } = useListEmployees({
    params: { departmentIds: department ? [department] : [], search },
    enabled: true,
  });

  const { data: departments } = useListDepartments({ params: {} });

  const onEmployeeSelect = (e: any) => {
    const employeeId = e?.target?.value;

    const employeeDetails = data?.find(
      (employee: any) => +employee.id === +employeeId,
    );

    if (!employeeDetails) return;

    handleEmployeeSelect({
      id: employeeId,
      name: employeeDetails.name,
      designation: employeeDetails.designationName,
      profileImage: employeeDetails?.profileImage,
    });
  };

  const _data = useMemo(() => {
    if (!data || data.length === 0) return [];

    let filteredData = [];

    if (firstEmployeeId) {
      filteredData = data?.filter(
        (employee: any) => +employee.id !== +firstEmployeeId,
      );
    }

    return filteredData;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <div className="shitf-emp">
      <div className="shift-emp-filter-section">
        <p className="shift-emp-title">{translate('Swap To')}</p>
        <AutoComplete
          data={departments?.map((department: any) => ({
            id: department.id,
            label: department.name,
          }))}
          label={`${translate('All Departments')}`}
          onChange={(option: any) => {
            handleFilterChange(option?.id || null);
          }}
          inputProps={{
            fullWidth: true,
            InputLabelProps: {
              classes: { root: 'auto-complete-input' },
            },
          }}
          className="auto-complete"
          autoCompleteProps={{
            classes: {
              input: 'auto-complete-input2',
              inputRoot: 'auto-complete-input2-root',
            },
          }}
        />
      </div>

      <SearchComponent
        onChange={(value: any) => setSearch(value)}
        classes={{
          container: { root: 'search-bar' },
          input: { input: 'search-input' },
        }}
      />

      <div className="shif-emp-list">
        {isLoading ? (
          <div className="loader-container">
            <Loader width={100} height={100} />
          </div>
        ) : _data?.length > 0 ? (
          <CustomRadioGroup onChange={onEmployeeSelect}>
            {_data?.map((employee: any) => {
              return (
                <div className="radio-btn-container">
                  <RadioButton
                    key={employee.id}
                    value={employee.id}
                    classes={{
                      root: 'radio-root',
                    }}
                    controllerProps={{
                      classes: { root: 'radio-controller-root' },
                    }}
                  />
                  <p className="emp-id">{employee?.staffId}</p>
                  <EmployeeCard
                    empName={employee?.name}
                    profileImage={employee?.profileImage}
                  />
                </div>
              );
            })}
          </CustomRadioGroup>
        ) : (
          <div className="list-no-data">
            <FilterAltIcon className="list-no-data-icon" />
            {translate('no-data')}
          </div>
        )}
      </div>
    </div>
  );
}
